import React, { useContext, useEffect, useState } from "react"
import { useLocation } from "react-router-dom"

const ThemeContext = React.createContext()

export function useTheme() {
  return useContext(ThemeContext)
}

export function ThemeProvider({ children }) {
  const [collapsed, setCollapsed] = useState(false)
  const [fullCollapsed, setFullCollapsed] = useState(false)
  const [siderFixed, setSiderFixed] = useState(true)
  const [headerFixed, setHeaderFixed] = useState(true)
  const [pathname, setPathname] = useState("")

  const location = useLocation()

  useEffect(() => {
    let pathname = location.pathname.split("/")
    if (pathname != null) {
      setPathname(pathname[1])
    }
  }, [location.pathname])

  const keysFromPath = (path) => {
    let pathname = path.split("/")
    if (pathname != null) {
      return pathname[1]
    }
    return ""
  }

  const toggleCollapse = () => {
    console.log("toggleCollapse")
    setCollapsed(!collapsed)
  }

  const toggleFullCollapse = () => {
    console.log("toggleFullCollapse")
    setCollapsed(!fullCollapsed)
    setFullCollapsed(!fullCollapsed)
  }

  const value = {
    pathname,
    keysFromPath,
    siderFixed,
    setSiderFixed,
    headerFixed,
    setHeaderFixed,
    fullCollapsed,
    setFullCollapsed,
    toggleFullCollapse,
    collapsed,
    setCollapsed,
    toggleCollapse
  }

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  )
}
